import { connect } from 'react-redux'

import Detail from './units'

function mapStateToProps(state) {
  return {
    product: state.ProductDetail,
    topic: state.ProductDetail.data.productTags,
    portfolioStatus: state.ProductPortfolio.status,
    productPortfolios: state.ProductDetail.portfolios,
    data: state.ProductDetail.data,
    isLoading: state.ProductDetail.isLoading,
    errorMessage: state.ProductDetail.errorMessage,
  }
}

export default connect(
  mapStateToProps,
)(Detail)
